import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function LPTokens({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 50 50" fill="currentColor">
      <path d="M5.92,30a24.06,24.06,0,0,1,24-24,23.79,23.79,0,0,1,4.73.47,20,20,0,1,0-28.3,28.3A23.79,23.79,0,0,1,5.92,30Z" />
      <path d="M36.81,25.54H34.13v4.92h2.68a3.51,3.51,0,0,0,2.25-.63,2.55,2.55,0,0,0,0-3.65A3.45,3.45,0,0,0,36.81,25.54Z" />
      <path d="M30,9.92A20,20,0,1,0,50,30,20.06,20.06,0,0,0,30,9.92ZM29,37.05H18.61V22.87h3.28V34.38H29ZM42.4,30.74a4.72,4.72,0,0,1-2.14,1.78,8,8,0,0,1-3.27.62H34.13v3.91H30.85V22.87H37a8,8,0,0,1,3.27.62A4.71,4.71,0,0,1,43.15,28,5,5,0,0,1,42.4,30.74Z" />
    </SvgIcon>
  )
}
